import Cookies from 'js-cookie'

export default {
    computed: {
        feedSwitch: {
            get() {
                return this.$store.state.feedSwitch;
            },

            set(val) {
                this.$store.commit('setFeedSwitch', val);
                this.$store.commit('resetFeed');

                let option = 'option1';

                //if turned on, set to option2
                if(val === true) {
                    option = 'option2';
                }

                Cookies.set('feedstatus', option, {
                    expires: 365
                });
            }
        }
    },

    props: {
        switchOneIcon: {
            type: String,
        },
        switchOneText: {
            type: String,
            required: true
        },
        switchTwoIcon: {
            type: String,
        },
        switchTwoText: {
            type: String,
            required: true
        },
    },

    mounted() {
        let cookie = Cookies.get('feedstatus');

        if(cookie !== undefined) {
            if(cookie === 'option2') {
                this.$store.commit('setFeedSwitch', true);
            } else {
                this.$store.commit('setFeedSwitch', false);
            }
        }
    }
}